import { Scale } from '../model/scale';

export const SCALE : Scale = {
    screen:{
        offset:{left:0,top:0},
        pixels: 200,
        meters:1, // dlugosc powyzszych pixeli w metrach
        step: 0.2, // krok - o ile zmienic metry przy skalowaniu
        ratio: 1, //skala powiekszenia np 1.5 oznacza 150% powiekszenia
        metersPerPx: 0.005,
        default:{
            pixels: 200,
            meters: 1,
            metersPerPx: 0.005,
            ratio: 1
        }
    },
    // view:{
    //     scale:1
    // }
}
